import translations from '$lib/translations/survey-player.yaml';

export function getTranslations(language: string) {
  const currentTranslations = translations[language] || translations.en_us;
  return {
    skipText: currentTranslations.skip,
    submitText: currentTranslations.submit,
    retryText: currentTranslations.retry,
    continueText: currentTranslations.continue,
    profileResults: currentTranslations.profile_results,
    leaderboard: {
      yourPosition: currentTranslations.leaderboard_your_position,
      rank: currentTranslations.leaderboard_rank,
      percentile: currentTranslations.leaderboard_percentile,
      time: currentTranslations.leaderboard_time,
      finalScore: currentTranslations.leaderboard_final_score,
      participant: currentTranslations.leaderboard_participant,
      score: currentTranslations.leaderboard_score,
      previous: currentTranslations.leaderboard_previous,
      next: currentTranslations.leaderboard_next,
      pageOf: currentTranslations.leaderboard_page_of,
      basedOnSingle: currentTranslations.leaderboard_based_on_single,
      basedOnMultiple: currentTranslations.leaderboard_based_on_multiple,
      loading: currentTranslations.leaderboard_loading,
      error: currentTranslations.leaderboard_error
    }
  };
} 